var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editing-reservation-banner" }, [
    _c("span", { staticClass: "icon-bell-gold" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editing-reservation-banner__wrapper" },
      [
        _c("p", { staticClass: "editing-reservation-banner__title" }, [
          _vm._v(_vm._s(_vm.ModifyReservationBookingWizardTitle)),
        ]),
        _vm._v(" "),
        _vm.isRoomList
          ? _c(
              "p",
              { staticClass: "editing-reservation-banner__description" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.ModifyReservationBookingWizardSubTitle) +
                    "\n    "
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("modify-edit-discard-modal", {
          attrs: {
            text: _vm.ModifyReservationDiscardPopupMessageTitle,
            "button-label": _vm.ModifyReservationDiscardPopupCTALabel,
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (ref) {
                var activate = ref.activate
                return _c("div", {}, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "editing-reservation-banner__button button--secondary black size-md outlined",
                      on: {
                        click: activate,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return activate($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.ModifyReservationBookingWizardCTADiscardLabel
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ])
              },
            },
          ]),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }